import React from 'react';
import { bool, shape, string } from 'prop-types';

const WaterSprayer = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.623 17.0684L21.1055 19.001L18.207 18.2246L18.7246 16.293L21.623 17.0684Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 19H9C7.80006 19 6.7 18.5001 6 17.7002C5.8 17.5002 5.4 17 5 17H3C2.4 17 2 16.6 2 16V8C2 7.4 2.4 7 3 7H5C5.39987 7 5.79994 6.60046 6 6.40039C6.7 5.60039 7.8 5 9 5H12V19ZM9 7C8.4 7 7.9 7.3002 7.5 7.7002C7.30003 8.00012 7.09976 8.20042 6.7998 8.40039C6.29987 8.80023 5.69986 9 5 9H4V15H5C5.69999 15 6.29981 15.3002 6.7998 15.7002C7.0998 15.9002 7.3 16.1004 7.5 16.4004C7.89997 16.8003 8.4001 17 9 17H10V7H9Z" fill="currentColor" />
    <path d="M16.793 15.7744L16.2754 17.707L13.3779 16.9307L13.8945 14.998L16.793 15.7744Z" fill="currentColor" />
    <path d="M17.501 13H14.501V10.999H17.5L17.501 13Z" fill="currentColor" />
    <path d="M22.5 13H19.5V11H22.5V13Z" fill="currentColor" />
    <path d="M16.793 8.22461L13.8955 9.00098L13.3779 7.06934L16.2754 6.29297L16.793 8.22461Z" fill="currentColor" />
    <path d="M21.623 6.93066L18.7256 7.70703L18.207 5.77539L21.1055 4.99805L21.623 6.93066Z" fill="currentColor" />
  </svg>
);

WaterSprayer.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default WaterSprayer;
